import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from 'react-dom';
import Listings from './modules/Listings';
import VisitorInfoCentres from './modules/VisitorInfoCentres';
import WishlistMap from './modules/WishlistMap';
import { StateProvider } from './state/state';
/**
 * Constants
 */
const blog = document.getElementById('blog-articles');
const eventCalendar = document.getElementById('events-calendar');
const news = document.getElementById('news-articles');
const operatorsFilters = document.getElementById('operators-filters');
const searchResults = document.getElementById('search-results');
const specialEventsCalendar = document.getElementById('special-events-calendar');
const visitorInfoCentres = document.getElementById('visitor-info-centres');
const wishlistMap = document.getElementById('wishlist-map');
if (blog) {
    const categories = blog.getAttribute('data-categories');
    const regions = blog.getAttribute('data-regions');
    const sort = blog.getAttribute('data-sort');
    const posts = (_jsx(StateProvider, { children: _jsx(Listings, { categories: categories, postType: "post", regions: regions, sort: sort }) }));
    ReactDOM.render(posts, blog);
}
if (eventCalendar) {
    const categories = eventCalendar.getAttribute('data-categories');
    const date = eventCalendar.getAttribute('data-date');
    const map = eventCalendar.hasAttribute('data-map');
    const regions = eventCalendar.getAttribute('data-regions');
    const region = eventCalendar.getAttribute('data-region');
    const search = eventCalendar.hasAttribute('data-search');
    const placeholder = eventCalendar.getAttribute('data-search-placeholder');
    const sort = eventCalendar.getAttribute('data-sort');
    const calendar = (_jsx(StateProvider, { children: _jsx(Listings, { categories: categories, date: date, showMap: map, postType: "event", region: region, regions: regions, search: search, searchPlaceholder: placeholder, sort: sort }) }));
    ReactDOM.render(calendar, eventCalendar);
}
if (news) {
    const categories = news.getAttribute('data-categories');
    const sort = news.getAttribute('data-sort');
    const posts = (_jsx(StateProvider, { children: _jsx(Listings, { categories: categories, postType: "news", sort: sort }) }));
    ReactDOM.render(posts, news);
}
if (operatorsFilters) {
    const category = operatorsFilters.getAttribute('data-category');
    const categories = operatorsFilters.getAttribute('data-categories');
    const accessibility = operatorsFilters.getAttribute('data-accessibility');
    const date = operatorsFilters.getAttribute('data-date');
    const organisations = operatorsFilters.getAttribute('data-organisations');
    const map = operatorsFilters.hasAttribute('data-map');
    const postTypes = operatorsFilters.getAttribute('data-post-type');
    const regions = operatorsFilters.getAttribute('data-regions');
    const region = operatorsFilters.getAttribute('data-region');
    const title = operatorsFilters.getAttribute('data-title');
    const sort = operatorsFilters.getAttribute('data-sort');
    const accreditation = operatorsFilters.getAttribute('data-accreditation');
    const operators = (_jsx(StateProvider, { children: _jsx(Listings, { accessibility: accessibility, category: category, categories: categories, organisations: organisations, date: date, showMap: map, postType: postTypes ? postTypes : 'post', region: region, regions: regions, title: title ? title : '', sort: sort, accreditation: accreditation }) }));
    ReactDOM.render(operators, operatorsFilters);
}
if (searchResults) {
    const categories = searchResults.getAttribute('data-categories');
    const postTypes = searchResults.getAttribute('data-post-type');
    const regions = searchResults.getAttribute('data-regions');
    const search = searchResults.hasAttribute('data-search');
    const placeholder = searchResults.getAttribute('data-search-placeholder');
    const sort = searchResults.getAttribute('data-sort');
    const posts = (_jsx(StateProvider, { children: _jsx(Listings, { categories: categories, postType: postTypes ? postTypes : 'post', search: search, searchPlaceholder: placeholder, regions: regions, sort: sort }) }));
    ReactDOM.render(posts, searchResults);
}
if (specialEventsCalendar) {
    const categories = specialEventsCalendar.getAttribute('data-categories');
    const date = specialEventsCalendar.getAttribute('data-date');
    const map = specialEventsCalendar.hasAttribute('data-map');
    const events = specialEventsCalendar.getAttribute('data-events');
    const sort = specialEventsCalendar.getAttribute('data-sort');
    const calendar = (_jsx(StateProvider, { children: _jsx(Listings, { categories: categories, date: date, showMap: map, postType: "event", postIn: events, sort: sort }) }));
    ReactDOM.render(calendar, specialEventsCalendar);
}
if (visitorInfoCentres) {
    const centre = (_jsx(StateProvider, { children: _jsx(VisitorInfoCentres, {}) }));
    ReactDOM.render(centre, visitorInfoCentres);
}
if (wishlistMap) {
    const map = (_jsx(StateProvider, { children: _jsx(WishlistMap, {}) }));
    ReactDOM.render(map, wishlistMap);
}
